'use memo'

import { useFormik, type FormikProps } from 'formik'
import {
  DEFAULT_PLUGIN_EMBED_SETTINGS,
  getPluginSettingsErrors,
  type PluginEmbedSettings,
} from '@sportninja/common/features/account/apiAccess'
import { toFormikErrors } from '../utils/toFormikErrors'

/** Nothing is saved: the builder only turns its values into a snippet. */
const neverSubmitted = () => undefined

/**
 * The snippet builder's form. Starts from the plugin's defaults on the
 * account's root organization, and validates on every change so the snippet
 * and preview can leave out whatever is invalid. The rules report flat paths;
 * Formik wants them nested.
 */
export const usePluginEmbedForm = (
  organizationId: string | null
): FormikProps<PluginEmbedSettings> =>
  useFormik<PluginEmbedSettings>({
    initialValues: {
      ...DEFAULT_PLUGIN_EMBED_SETTINGS,
      entityId: organizationId ?? '',
    },
    validate: (values) => toFormikErrors(getPluginSettingsErrors(values)),
    validateOnChange: true,
    validateOnBlur: false,
    validateOnMount: true,
    onSubmit: neverSubmitted,
  })
